export default __webpack_public_path__ + "mini-crm-for-your-app.jpg";